/*
 * Collection inifinite scroll and restore scroll position
 */

let currentPage = 1;
let container = document.querySelector('.products-grid');
let intersectionObserver;
const trigger = document.querySelector('.collection-load-more');
let totalPages = trigger?.dataset?.pages ? parseInt(trigger.dataset.pages, 10) : 1;

// Fetch products with pagination
async function getProducts() {
  if (!trigger) {
    console.log('[Infinite Scroll] No trigger present, skipping fetch.');
    return;
  }
  if (!container) {
    console.log('[Infinite Scroll] No product grid available.');
    return;
  }
  // Return if no more pages and increment current page
  if (currentPage === totalPages) {
    removeSkeletonLoaders();
    trigger.remove();
    return;
  }
  currentPage += 1;

  try {
    // Fetch next page products
    const url = new URL(window.location.href);
    url.searchParams.set('page', currentPage.toString());
    const fetchUrl = url.toString();
    
    const response = await fetch(fetchUrl);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const text = await response.text();

    // Convert to HTML
    const parser = new DOMParser();
    const html = parser.parseFromString(text, 'text/html');

    // Append next page products to container
    const grid = html?.querySelector('.products-grid')?.children;
    
    if (!grid) {
      throw new Error('No products grid found in response');
    }
    
    // Filter out <template> elements from the grid - parameter push-up functionality
    const filteredGrid = [...grid].filter((node) => node.tagName !== 'TEMPLATE');

    // Remove skeletons before appending real products
    removeSkeletonLoaders();
    
    // Append products with a slight delay for smoother transition
    setTimeout(() => {
      container.append(...filteredGrid);
      if (intersectionObserver) {
        intersectionObserver.observe(trigger);
      }
      // Dispatch event for grid swatch images
      document.dispatchEvent(new CustomEvent('collection:paginated'));
    }, 100);
    
  } catch (error) {
    console.error('[Infinite Scroll] Error loading products:', error);
    removeSkeletonLoaders();
    
    // Show error message to user
    const errorDiv = document.createElement('div');
    errorDiv.className = 'collection-load-error';
    errorDiv.innerHTML = `
      <p>Fehler beim Laden weiterer Produkte.</p>
      <button onclick="location.reload()" class="btn">Seite neu laden</button>
    `;
    if (trigger?.before) {
      trigger.before(errorDiv);
    }
  }
}

// Get grid width classes from existing products
function getGridWidthClasses() {
  const firstProduct = container?.querySelector('.grid-product:not(.skeleton-loader)');
  if (!firstProduct) {
    console.log('[Infinite Scroll] No products found, using fallback grid classes');
    // Default fallback for 4 columns
    return 'small--one-half medium-up--one-quarter';
  }
  
  // Extract all grid width classes
  const classes = Array.from(firstProduct.classList);
  const gridClasses = classes.filter(
    (cls) =>
      cls.includes('one-half') ||
      cls.includes('one-third') ||
      cls.includes('one-quarter') ||
      cls.includes('one-fifth') ||
      cls.includes('one-sixth') ||
      cls.includes('small--') ||
      cls.includes('medium-up--') ||
      cls.includes('large-up--')
  );
  
  const gridClassString = gridClasses.length > 0 ? gridClasses.join(' ') : 'small--one-half medium-up--one-quarter';
  console.log('[Infinite Scroll] Using grid classes:', gridClassString);
  
  return gridClassString;
}

// Create skeleton loader elements
function createSkeletonLoaders(count = 8) {
  const skeletons = [];
  const gridWidthClasses = getGridWidthClasses();
  
  for (let i = 0; i < count; i++) {
    const skeleton = document.createElement('div');
    skeleton.className = `grid__item grid-product skeleton-loader ${gridWidthClasses}`;
    skeleton.setAttribute('aria-hidden', 'true');
    skeleton.innerHTML = `
      <div class="grid-product__content">
        <div class="skeleton-loader__image"></div>
        <div class="skeleton-loader__title"></div>
        <div class="skeleton-loader__price"></div>
      </div>
    `;
    skeletons.push(skeleton);
  }
  return skeletons;
}

// Show skeleton loaders
function showSkeletonLoaders() {
  if (!trigger || !container) return;
  
  // Hide the default loader spinner
  const defaultLoader = trigger.querySelector('.loader');
  if (defaultLoader) {
    defaultLoader.style.display = 'none';
  }
  
  // Hide loading image if exists
  const loadingImage = trigger.querySelector('img');
  if (loadingImage) {
    loadingImage.style.display = 'none';
  }
  
  // Add loading class to trigger
  trigger.classList.add('skeleton-active');
  
  // Insert skeletons INTO the grid container (not before trigger)
  const skeletons = createSkeletonLoaders(8);
  container.append(...skeletons);
  
  console.log('[Infinite Scroll] Showing', skeletons.length, 'skeleton loaders');
  
  return skeletons;
}

// Remove skeleton loaders
function removeSkeletonLoaders() {
  if (!trigger) return;
  
  // Show the default loader again (for next page)
  const defaultLoader = trigger.querySelector('.loader');
  if (defaultLoader) {
    defaultLoader.style.display = '';
  }
  
  // Show loading image again
  const loadingImage = trigger.querySelector('img');
  if (loadingImage) {
    loadingImage.style.display = '';
  }
  
  trigger.classList.remove('skeleton-active');
  
  // Remove all skeleton elements with fade out
  document.querySelectorAll('.skeleton-loader').forEach(el => {
    el.style.opacity = '0';
    setTimeout(() => el.remove(), 150);
  });
}

// Intersection observer for load more trigger
if (trigger) {
  intersectionObserver = new IntersectionObserver(
    (entries) => {
      const isIntersecting = entries[0]?.isIntersecting ?? false;
      if (isIntersecting) {
        // Show skeletons immediately for better UX
        showSkeletonLoaders();
        
        // Fetch products (will remove skeletons when done)
        getProducts();
      }
    },
    {rootMargin: '-10% 0px 0px 0px'}
  );
} else {
  console.log('[Infinite Scroll] No load-more trigger detected. Infinite scroll disabled.');
}

// Check if navigation by back button
const isBackNavigation = () => {
  const perfEntries = performance.getEntriesByType('navigation');
  for (let i = 0; i < perfEntries?.length; i += 1) {
    if (perfEntries[i]?.type === 'back_forward') {
      return true;
    }
  }
  return false;
};

// Restore scroll position on back navigation
const restoreScrollState = async () => {
  const scrollPosition = sessionStorage.getItem('scrollPosition');
  const pagesToLoad = parseInt(sessionStorage.getItem('currentPage'), 10);

  if (scrollPosition === null) return;
  window.history.scrollRestoration = 'manual';
  // Fetch products
  for (let i = 1; i < pagesToLoad; i += 1) {
    // eslint-disable-next-line no-await-in-loop
    await getProducts();
  }

  // Smooth scrolling
  setTimeout(() => window.scrollTo({top: scrollPosition, behavior: 'smooth'}), 1000);
  sessionStorage.removeItem('scrollPosition');
};

// Event listeners for back navigation (scroll position), collection reload, DOM content loaded
window.addEventListener('beforeunload', () => {
  sessionStorage.setItem('scrollPosition', window.scrollY);
  sessionStorage.setItem('currentPage', currentPage);
});

// ios fix
window.addEventListener('onpagehide', () => {
  sessionStorage.setItem('scrollPosition', window.scrollY);
  sessionStorage.setItem('currentPage', currentPage);
});

document.addEventListener('DOMContentLoaded', () => {
  if (!trigger || !intersectionObserver) return;
  intersectionObserver.observe(trigger);

  if (isBackNavigation()) {
    restoreScrollState();
  }
});

document.addEventListener('collection:reloaded', () => {
  currentPage = 1;
  container = document.querySelector('.products-grid');
  if (trigger?.dataset?.pages) {
    totalPages = parseInt(trigger.dataset.pages, 10);
  }
  if (trigger && intersectionObserver) {
    intersectionObserver.observe(trigger);
  }
});
